// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--NgcQ5","control-wrapper":"_9e1425b4d3--control-wrapper--CWBlu","prev":"_9e1425b4d3--prev--L_RZ0","next":"_9e1425b4d3--next--YpSAR"};